import { ColumnDefinition } from '../../../sharedComponents/table/SortedTableHeader';

export enum ServiceOptionsTableColumns {
    EXTERNAL_ID = 'externalId',
    STATUS = 'status',
    VIN = 'vin',
    LOCATION_ID = 'locationId',
    LOCATION_CITY = 'locationCity',
    MANUFACTURER = 'manufacturer',
    MODEL = 'model',
    ORDER_ISSUE_DATE = 'orderIssueDate',
    NUMBER_OF_SERVICES = 'numberOfServices',
    ACTION_BUTTON = 'actionButton',
}

export const serviceOptionColumnDefinition: ColumnDefinition<ServiceOptionsTableColumns>[] = [
    {
        column: ServiceOptionsTableColumns.EXTERNAL_ID,
        labelId: 'outboundOrderBook.serviceOptions.table.identifier',
        sortable: false,
        alwaysVisible: true,
    },
    { column: ServiceOptionsTableColumns.STATUS, labelId: 'outboundOrderBook.common.heading.status', sortable: true },
    {
        column: ServiceOptionsTableColumns.VIN,
        labelId: 'outboundOrderBook.common.heading.vin',
        sortable: false,
        alwaysVisible: true,
    },
    {
        column: ServiceOptionsTableColumns.LOCATION_ID,
        labelId: 'outboundOrderBook.serviceOrder.table.heading.locationId',
        sortable: true,
    },
    {
        column: ServiceOptionsTableColumns.LOCATION_CITY,
        labelId: 'outboundOrderBook.serviceOrder.table.heading.location',
        sortable: false,
    },
    {
        column: ServiceOptionsTableColumns.MANUFACTURER,
        labelId: 'outboundOrderBook.common.heading.manufacturer',
        sortable: false,
    },
    {
        column: ServiceOptionsTableColumns.MODEL,
        labelId: 'outboundOrderBook.common.heading.model',
        sortable: false,
    },
    {
        column: ServiceOptionsTableColumns.ORDER_ISSUE_DATE,
        labelId: 'outboundOrderBook.common.heading.orderIssuedAt',
        sortable: true,
    },
    {
        column: ServiceOptionsTableColumns.NUMBER_OF_SERVICES,
        labelId: 'outboundOrderBook.serviceOptions.table.numberOfServices',
        sortable: false,
    },
    {
        column: ServiceOptionsTableColumns.ACTION_BUTTON,
        labelId: 'outboundPortal.serviceOrders.table.action',
        sortable: false,
    },
];
